module.exports = __webpack_public_path__ + "img/20180815_152858_223.846c824d.jpg";